/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

import {getSelectedObjectsProperty} from './../utils/common'

// Template for the Dropdown
const selectLocationsTemplate = `
<div uib-dropdown class="select-locations inlineBlock margin-r20 ui-select color-dropdown-ml" style="margin-left: 0;width: 100%;" >
  <style>
  .select-locations .dropdown-toggle,
  .select-locations .dropdown-toggle:active,  
  .select-locations .dropdown-toggle:hover,
  .select-locations .dropdown-button.dropdown-toggle:focus {
    border: none;
  }
  .dropdown-button{
    color: #242633;
    padding: 6px 10px 6px 10px;
    width: 100%;
    font-size: 14px;
    font-weight: inherit;
    letter-spacing: normal;
    text-transform: unset;
    border-color: transparent;
    margin: 0;
    text-align: left;
  }
  .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {
    background-color: transparent;
    color: #242633;
  }
  .dropdown .locationsDropdown{
    max-height: 300px;
    width: 285px;
  }
  .practice-area-list {
    padding-left: 38px;    
  }
  .practice-area-list li{
    padding: 2px 0;
  }
  </style>
  <div uib-dropdown>
    <button uib-dropdown-toggle id="{{buttonId}}" class="btn-noline-info btn-xs dropdown-button" type="button">
      Locations
  </button>
    <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown">
      <div class = "pull-right">
      <button ng-click="selectAllLocations()" class="btn btn-info btn-xs">Select All</button>
        <button ng-click="unselectAllLocations()" class="btn btn-info btn-xs">Deselect All</button>
      </div>
      <br />

      <div class="" data-ng-repeat = "region in nrefLocations | orderBy: 'loc_ID'">
        <label class="ui-checkbox">
            <input type="checkbox" ng-click="selectLocation($event , region , 2)" data="{{loc_ID}}" ng-model="region.isSelected">
            <span class="checkbox-group-heading"><strong>{{region.loc_name}}</strong></span>
        </label>
        <ul class=" practice-area-list clearfix">
            <li data-ng-repeat="location in region.locations">
                <label class="ui-checkbox">
                    <input type="checkbox"
                        data="{{location.loc_ID}}"
                        ng-click="selectLocation($event , location , 1)"
                        ng-checked="location.isSelected"
                        ng-model="location.isSelected"
                    >
                    <span>{{location.loc_name}}</span>
                </label>
              <ul class=" sub-list clearfix">
                <li data-ng-repeat = "sub in location.sub_areas">
                    <label class="ui-checkbox">
                        <input type="checkbox"
                            ng-click="selectLocation($event , sub , 0)"
                            ng-checked="sub.isSelected"
                            ng-model="sub.isSelected">
                        <span>{{sub.loc_name}}</span>
                    </label>
                  </li>
              </ul>
            </li>
        </ul>
      </div>
    </div>
  </div>
</div>
`

// Controller for the dropdown directive
const selectLocationsController = ($scope, $timeout, locationsService) => {
  const stopEventExecution = event => {
    event.stopPropagation()
  }

  $('.bootstrapDropdown').click(stopEventExecution)

  // Method to update the outside scope's locations model
  // model will be used outside the directive(inside parent's
  // controller)
  const updateLocsModel = (allowUpdate = true) => {
    const updateAndNotify = (values = []) => {
      $scope.locsModel = values
      $scope.onLocsChange()
      $timeout(() => $scope.$apply())
    }

    //If model is not provided just notify the parent
    // to update itself
    if (!$scope.hasOwnProperty('locsModel') || !allowUpdate) {
      updateAndNotify([])
      return
    }

    //If model is provided, filter the ids of the selected
    // objects and notify parent
    getSelectedObjectsProperty(
      locationsService.linearize($scope.nrefLocations),
      'loc_ID'
    ).then(updateAndNotify)
  }

  // Unselection of all Locations
  $scope.unselectAllLocations = () => {
    locationsService.clearSelection($scope.nrefLocations, false)
    updateLocsModel(false)
  }

  $scope.selectAllLocations = () => {
    locationsService.clearSelection($scope.nrefLocations, true)
    updateLocsModel(false)
  }

  // Selects a particular location
  $scope.selectLocation = (event, current, level) => {
    locationsService.select(
      $scope.nrefLocations,
      event,
      current,
      level,
      $scope.count
    )
    updateLocsModel()
  }
}

// returns DDO for the dropdown
const selectLocations = () => {
  return {
    restrict: 'AE',
    scope: {
      buttonId: '@',
      locsModel: '=?',
      nrefLocations: '=',
      onLocsChange: '&',
      selectOnReset: '=?',
    },
    replace: true,
    template: selectLocationsTemplate,
    controller: selectLocationsController,
  }
}

angular.module('app.directives').directive('selectLocations', selectLocations)



// WEBPACK FOOTER //
// ./scripts/shared/directives/select-locations.js